<template>
  <div class="client-user-header">
    <div class="logo">
      <div class="logo-icon">
        <!-- <img src="@/assets/img/kp-logo.png" width="100%" /> -->
        <svg-icon icon-name="logo-kpmg" size="74" style="color: #00338d;"></svg-icon>
      </div>
      <span class="txt">{{ $t('COMMON_PROJECT_NAME') }}</span>
    </div>
    <div class="header-right">
      <div class="header-user-con">
        <div class="btns">
          <!-- 切换全屏 -->
          <el-tooltip placement="bottom">
            <template #content> {{ fullscreen ? $t('full_no_screen') : $t('full_screen') }} </template>
            <template>
              <div class="btn" @click="handleFullScreen">
                <svg-icon :icon-name="fullscreen ? 'icon-Exit-fullscreen' : 'icon-fullscreen'" :size="16"
                  style="color: #0d386d"></svg-icon>
              </div>
            </template>
          </el-tooltip>
          <el-divider direction="vertical"></el-divider>
          <!-- 切换语言 -->
          <el-tooltip placement="bottom">
            <template #content> {{ $t('i18n_btn') }} </template>
            <template>
              <div class="btn" @click="changeI18n">
                <svg-icon :icon-name="this.$i18n.locale === 'zh' ? 'icon-EN' : 'icon-CN'" :size="16"
                  style="color: #0d386d"></svg-icon>
              </div>
            </template>
          </el-tooltip>
          <el-divider direction="vertical"></el-divider>
          <!-- faq -->
          <el-tooltip placement="bottom">
            <template #content> {{ $t('FAQ_TITLE') }} </template>
            <template>
              <div class="btn" @click="handleFaq">
                <svg-icon icon-name="icon-FAQ" :size="16" style="color: #0d386d"></svg-icon>
              </div>
            </template>
          </el-tooltip>


        </div>
        <el-popover placement="bottom" trigger="click" popper-class="qr-code-popover" :visible-arrow="false">
          <img :src="$i18n.locale === 'en' ? qrCodeEn : qrCodeCn" class="qr-code">
          <div class="qr-txt">
            <p class="font-bold text1">
              {{ $t('newsMgt.title4') }}
            </p>
            <!-- <p class="text2">{{ $t('newsMgt.scanTips') }}</p> -->
          </div>
          <div class="qr" slot="reference">
            <svg-icon icon-name="qr-code" style="color: #fff"></svg-icon>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/api'
import { mapGetters } from 'vuex'

import SvgIcon from "@/components/svgIcon/index";

export default {
  name: 'AsideLeft',
  components: { SvgIcon },
  data() {
    return {
      user: {},
      fullscreen: false,
      qrCodeCn: require(`@/assets/img/qrCodeCn.png`),
      qrCodeEn: require(`@/assets/img/qrCodeEn.png`)
    }
  },
  computed: {
    ...mapGetters('common', {
      getUser: 'getUser'
    }),
  },
  mounted() {
    this.user = { ...this.getUser }
  },
  inject: ['reload'],
  methods: {
    // 全屏事件
    handleFullScreen() {
      let element = document.documentElement
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen()
        }
      }
      this.fullscreen = !this.fullscreen
    },
    changeI18n() {
      let locale = this.$i18n.locale
      locale === 'zh' ? (this.$i18n.locale = 'en') : (this.$i18n.locale = 'zh')
      localStorage.setItem('lang', this.$i18n.locale)
      API.common.changeLanguage({ param: this.$i18n.locale }).then(res => {
        if (res.code == '1') {
          this.reload()
          window.reloadPageByI18n && window.reloadPageByI18n(this.$i18n)
        }
      })
    },
    handleFaq() {
      window.open(this.$t(`faq_${this.user.userType}`), '_blank')
    },
  }
}
</script>

<style scoped>
.client-user-header {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
}

.logo-icon {
  display: flex;
  width: 74PX;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.logo .txt {
  margin-left: 15px;
  font-weight: bold;
  font-size: 26PX;
  color: #00338d;
  font-family: 'KPMG';
}

.client-user-wrap.en-lang .logo .txt {
  font-size: 40PX;
}

.header-user-con {
  display: flex;
  align-items: center;
}

.header-user-con .qr {
  width: 33PX;
  height: 33PX;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(~@/assets/img/avatar_bg.png) no-repeat;
  background-size: cover;
  margin-left: 20PX;
}

.header-user-con ::v-deep .qr .svg-icon svg {
  width: 20PX;
}

.header-user-con .btns {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 8px 15px;
  border-radius: 5px;
  height: 35PX;
}

.client-user-header ::v-deep .el-divider {
  margin: 0 15px !important;
  position: relative;
  top: 1px;
}
</style>

<style>
.qr-code-popover {
  min-width: auto !important;
  background-image: url(~@/assets/img/bg_Overview.png) !important;
  background-size: 100% 100% !important;;
  background-repeat: no-repeat !important;
  box-shadow: none !important;
  border: none !important;
}

.qr-code-popover .qr-code {
  width: 130px;
}

.qr-code-popover .qr-txt {
  width: 130px;
  color: #fff;
  text-align: center;
}

.qr-code-popover .qr-txt .text1 {
  font-size: 14px;
  margin-top: 5px;
}
.qr-code-popover .qr-txt .text2 {
  font-size: 12px;
  color: #ebebeb;
  line-height: 16px;
  scale: 0.9;
}
</style>